// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"b37c81b3","55":"9f576f95","137":"c73b4db6","232":"b7a76203","516":"092e8d89","613":"292e475b","732":"e5847cf3","767":"b48f4ae8","807":"d9ae5e80","905":"2dc0e4a9","931":"bbc8bec5","964":"b2bcd64c"}[chunkId] + ".chunk.js";
};